(function () {
  const CART_UPDATE_COOKIE_NAME = 'BOLD_cart_last_updated';
  let lastCartUpdate = getBoldCartCookie();
  let lastEmitAt = 0;
  let upsellModalOpen = false;

  function getBoldCartCookie() {
    const cookie = document.cookie
      .split('; ')
      .find((item) => item.indexOf(`${CART_UPDATE_COOKIE_NAME}=`) === 0);

    return cookie ? cookie.split('=').slice(1).join('=') : '';
  }

  function emitBoldCartEvents() {
    if (upsellModalOpen) return;

    const eventEmitter = window.BOLD?.common?.eventEmitter;
    if (!eventEmitter || typeof eventEmitter.emit !== 'function') return;

    const now = Date.now();
    if (now - lastEmitAt < 300) return;
    lastEmitAt = now;

    eventEmitter.emit('BOLD_COMMON_cart_loaded');
    eventEmitter.emit('BOLD_COMMON_redirect_upsell_product');
  }

  function checkBoldCartCookie() {
    const currentCartUpdate = getBoldCartCookie();
    if (!currentCartUpdate || currentCartUpdate === lastCartUpdate) return;

    lastCartUpdate = currentCartUpdate;
    emitBoldCartEvents();
  }

  function bindUpsellModalState() {
    const upsellEmitter = window.BOLD?.upsell?.app?.ee;
    if (!upsellEmitter || upsellEmitter._speciesBound) return;

    upsellEmitter._speciesBound = true;
    if (typeof upsellEmitter.on === 'function') {
      upsellEmitter.on('modal_opened', function () {
        upsellModalOpen = true;
      });
      upsellEmitter.on('modal_closed', function () {
        upsellModalOpen = false;
        checkBoldCartCookie();
      });
    }
  }

  function decorateAddToCartButtons(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope
      .querySelectorAll(
        'form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [type="submit"][name="add"], .subscription-bundle-hero__ctaButton'
      )
      .forEach((button) => {
        button.classList.add('addtocart');
      });
  }

  function scheduleCartLoadedEvents() {
    window.setTimeout(window.SpeciesBoldUpsell.emitCartLoaded, 500);
    window.setTimeout(window.SpeciesBoldUpsell.emitCartLoaded, 1200);
  }

  window.SpeciesBoldUpsell = window.SpeciesBoldUpsell || {};
  window.SpeciesBoldUpsell.emitCartLoaded = function () {
    bindUpsellModalState();
    emitBoldCartEvents();
    checkBoldCartCookie();
  };

  if (window.cookieStore) {
    window.cookieStore.addEventListener('change', function (event) {
      const boldCookieChanged = event.changed.some((cookie) => cookie.name === CART_UPDATE_COOKIE_NAME);
      if (boldCookieChanged) checkBoldCartCookie();
    });
  } else {
    window.setInterval(checkBoldCartCookie, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindUpsellModalState();
      decorateAddToCartButtons();
    });
  } else {
    bindUpsellModalState();
    decorateAddToCartButtons();
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.addtocart, form[action*="/cart/add"] button[type="submit"]')) return;
    scheduleCartLoadedEvents();
  });

  document.addEventListener('submit', function (event) {
    if (!event.target.matches('form[action*="/cart/add"]')) return;
    scheduleCartLoadedEvents();
  });

  new MutationObserver(function (mutations) {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        decorateAddToCartButtons(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
